/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_500Inputs */

const en_api_error_500 = /** @type {(inputs: Api_Error_500Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An internal server error occurred.`)
};

const pt_br2_api_error_500 = /** @type {(inputs: Api_Error_500Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocorreu um erro interno no servidor.`)
};

/**
* | output |
* | --- |
* | "An internal server error occurred." |
*
* @param {Api_Error_500Inputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_500 = /** @type {((inputs?: Api_Error_500Inputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_500Inputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_500(inputs)
	return pt_br2_api_error_500(inputs)
});